var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7B7B7B",
  d: "M1.97 13.637a1.38 1.38 0 0 1-.974-.378 1.2 1.2 0 0 1-.406-.908V5.922q0-.53.406-.907.405-.378.975-.378h.69V3.35q0-1.334 1.01-2.274t2.442-.94 2.442.94 1.01 2.274v1.286h.69q.57 0 .975.378.406.378.405.907v6.429q0 .53-.405.908t-.975.378zm0-1.286h8.285V5.922H1.97zm4.143-1.929q.57 0 .975-.377.406-.378.405-.908 0-.531-.405-.908a1.39 1.39 0 0 0-.975-.378q-.572 0-.975.378a1.2 1.2 0 0 0-.406.908q-.002.528.406.908t.975.377M4.042 4.637h4.142V3.35q0-.804-.604-1.366-.605-.563-1.467-.563-.864 0-1.467.563T4.042 3.35z"
})));
export default SvgLock;